// True when the user is typing in a text field, so gallery keyboard shortcuts must stay quiet.
export const isTypingTarget = (target) =>
  !!target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName));
